import { render, staticRenderFns } from "./RequestDocs.vue?vue&type=template&id=31b89876&"
import script from "./RequestDocs.vue?vue&type=script&lang=js&"
export * from "./RequestDocs.vue?vue&type=script&lang=js&"
import style0 from "./RequestDocs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports